import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/monitoramento-protocolo`

    return {
        paciente: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-paciente?${urlUtil.serialize(queryParms)}`)
            }
        },
        usuarioResponsavel: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-usuario-responsavel?${urlUtil.serialize(queryParms)}`)
            }
        },
        datatable(queryParms = {}) {

            return repository.post(`${baseUrl}/datatable`, queryParms)
        },
        list(params) {

            return repository.post(`${baseUrl}/list`, params)
        },
        getAtendimentos(acompanhamentoOciId) {

            return repository.get(`${baseUrl}/atendimento/${acompanhamentoOciId}`)
        },
        getSolicitacoes(acompanhamentoOciId) {

            return repository.get(`${baseUrl}/solicitacao/${acompanhamentoOciId}`)
        },
        createEncerramentoOci(acompanhamentoOciId) {

            return repository.get(`${baseUrl}/create-encerramento-oci/${acompanhamentoOciId}`)
        },
        storeEncerramentoOci(acompanhamentoOciId, params) {

            return repository.post(`${baseUrl}/store-encerramento-oci/${acompanhamentoOciId}`, params)
        },
        updateSolicitacoes(params) {

            return repository.put(`${baseUrl}/update-solicitacao`, params)
        },
    }
}